import React from "react";
import Icon from "./Icon";

interface AdminStatCardProps {
  label: string;
  value: string | number;
  iconType?: string;
  iconName?: string;
  iconColor?: string;
  accentColor?: string;
}

/**
 * Compact summary stat card (icon circle + value + label) used in the
 * admin user-management summary row.
 */
const AdminStatCard: React.FC<AdminStatCardProps> = ({
  label,
  value,
  iconType,
  iconName,
  iconColor = "#FFA217",
  accentColor = "#FFF3E0",
}) => {
  return (
    <div className="flex flex-1 min-w-[140px] flex-col items-center rounded-xl bg-white px-2 py-3 shadow-sm">
      {iconType && iconName ? (
        <div
          className="mb-1.5 flex h-[34px] w-[34px] items-center justify-center rounded-full"
          style={{ backgroundColor: accentColor }}
        >
          <Icon iconType={iconType} name={iconName} size={18} color={iconColor} />
        </div>
      ) : null}
      <div className="text-lg font-bold text-[#222]">{value}</div>
      <div className="mt-0.5 w-full truncate text-center text-[11px] text-[#888]">
        {label}
      </div>
    </div>
  );
};

export default AdminStatCard;
